const chemistryImage = require('./assets/lab_chem.png');
const physicsImage = require('./assets/lab_physics.png');
const physicalImage = require('./assets/lab_physical.png');
const biologyImage = require('./assets/lab_biology.png');
const organicImage = require('./assets/lab_ochem.png');

const biologyBanner = require('./assets/biology_banner.png');
const chemistryBanner = require('./assets/chemistry_banner.png');
const organicBanner = require('./assets/organic_banner.png');
const physicsBanner = require('./assets/physics_banner.png');
const physicalBanner = require('./assets/physical_banner.png');

export default {
  labs: [
    {
      name: 'Chemistry',
      short: 'chemistry',
      icon: chemistryImage,
      banner: chemistryBanner,
    },
    {
      name: 'Organic Chemistry',
      short: 'organic',
      icon: organicImage,
      banner: organicBanner,
    },
    {
      name: 'Biology',
      short: 'biology',
      icon: biologyImage,
      banner: biologyBanner,
    },
    {
      name: 'Physics',
      short: 'physics',
      icon: physicsImage,
      banner: physicsBanner,
    },
    {
      name: 'Physical Science',
      short: 'physical_science',
      icon: physicalImage,
      banner: physicalBanner,
    },
  ],
};
